import React, { useRef } from "react";
import Webcam from "react-webcam";

interface CameraModalProps {
  isOpen: boolean;
  onCapture: (imageData: string) => void;
  currentStep: string;
}

const videoConstraints = {
  facingMode: "user",
};

const CameraModal: React.FC<CameraModalProps> = ({
  isOpen,
  onCapture,
  currentStep,
}) => {
  const webcamRef = useRef<Webcam>(null);

  const capture = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      if (imageSrc) {
        onCapture(imageSrc);
      }
    }
  };

  const getModalTitle = () => {
    switch (currentStep) {
      case "selfie":
        return "Upload Selfie";
      case "around":
        return "Upload Lokasi";
      case "document":
        return "Upload Dokumen";
      default:
        return "Take a Photo";
    }
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="p-4 bg-white rounded-lg shadow-lg w-96">
            <h2 className="mb-4 text-lg font-bold">{getModalTitle()}</h2>

            <Webcam
              ref={webcamRef}
              audio={false}
              screenshotFormat="image/png"
              videoConstraints={videoConstraints}
              className="w-full rounded"
            />

            <button
              onClick={capture}
              className="w-full px-4 py-2 mt-4 text-white bg-blue-500 rounded"
            >
              Capture
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default CameraModal;
